import SimplePage from "@/components/layout/SimplePage";

export default function Yahrzeit() {
  return (
    <SimplePage
      title="Yahrzeit"
      eyebrow="Remembrance"
      subtitle="Honoring the memory of those we have loved and lost."
      path="/worship/yahrzeit"
      ctaLabel="Request a yahrzeit reminder"
    >
      <p>
        <em>Yahrzeit</em> is the annual observance of the anniversary of a
        loved one's death, traditionally marked on the Hebrew date of passing.
        At Temple Israel of Brevard we honor the memory of our members'
        relatives in several ways throughout the year.
      </p>

      <h2>Friday-Night Remembrance</h2>
      <p>
        At every Friday Shabbat service, we read the names of those whose
        yahrzeit falls in the coming week and recite the Mourner's Kaddish
        together. Members of the community rise for Kaddish in solidarity with
        those in mourning.
      </p>

      <h2>Yizkor</h2>
      <p>
        Four times a year - on Yom Kippur, Shemini Atzeret, the last day of
        Passover, and Shavuot - we hold special Yizkor (memorial) services. All
        who have lost loved ones are warmly invited to attend.
      </p>

      <h2>Memorial Plaques</h2>
      <p>
        Permanent memorial plaques in our sanctuary may be dedicated in memory
        of a loved one. Each year on the yahrzeit, the corresponding plaque is
        illuminated. To inquire about a memorial plaque, please contact the
        office.
      </p>

      <h2>Yahrzeit Reminder Service</h2>
      <p>
        We are happy to send you an annual reminder of a loved one's yahrzeit -
        on both the English and Hebrew calendar dates - so the name can be read
        from the bimah and you can recite Kaddish with our community. To set up
        a yahrzeit reminder, please email{" "}
        <a href="mailto:tioffice@tiofbrevard.com">tioffice@tiofbrevard.com</a>{" "}
        with the deceased's name (English and Hebrew if known), the relationship
        to you, and the date of passing.
      </p>

      <h2>Pastoral Support</h2>
      <p>
        Rabbi Fanwick is available for pastoral conversation, shiva visits, and
        ongoing support for those experiencing loss. Please call the office or
        email{" "}
        <a href="mailto:rabbikarenfanwick@tiofbrevard.com">
          rabbikarenfanwick@tiofbrevard.com
        </a>{" "}
        to schedule a time to speak.
      </p>

      <p className="font-display text-xl text-[var(--blue-ink)] mt-8 italic">
        May the memories of our loved ones be a blessing. <span className="not-italic text-sm text-[var(--muted)]">Zichronam livracha.</span>
      </p>
    </SimplePage>
  );
}
